import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { reducerPaths } from "../../app/reducerPaths";
import { baseQueryWithAuth } from "../methods/baseQueryWithAuth";

export const myGarageApi = createApi({
  reducerPath: reducerPaths.myGarageApi, // Unique key in Redux store
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    submitCarForm: builder.query({
      query: ({ formData, endpoint }) => ({
        url: endpoint,
        method: "POST",
        body: formData,
        headers: {
          
        }
      }),
      invalidatesTags: ["getRecentlyAddedCars"]
    }),
    updateCar: builder.query({
      query: ({ formData, endpoint }) => {
        return {
          url: endpoint,
          method: "POST",
          body: formData,
        }
      }
    }),
    updateCarOnRelistPending: builder.mutation({
      query: ({ formData, Vehicle_Id }) => {
        return {
          url: `/updatevehicle/${Vehicle_Id}/Relist`,
          method: "POST",
          body: formData,
        };
      }
    }),
    // GET requests start...
    getRecentlyAddedCars: builder.query({
      query: ({ endpoint, params }) => {
        return {
          url: endpoint,
          method: "GET",
          params
        }
      },
      providesTags: ["getRecentlyAddedCars"]
    })
    // GET requests end...
  }),
});

export const { 
  useSubmitCarFormQuery, useUpdateCarQuery,
  useGetRecentlyAddedCarsQuery
} = myGarageApi;
export const {
  useLazySubmitCarFormQuery, useLazyUpdateCarQuery,
  useUpdateCarOnRelistPendingMutation,
  useLazyGetRecentlyAddedCarsQuery
} = myGarageApi;
